module.exports = __webpack_public_path__ + "img/cju_gallery6.882b1074.jpg";